import { inject, Injectable } from '@angular/core';
import { HeroEntity, HeroesByUserAndLiveGQL, HeroGQL, HeroMostPlayedByUserGQL } from '@generated/gql';
import { BaseSubgraphService } from '@services/graph/base-subgraph.service';
import { EMPTY, expand, map, Observable, reduce, retry } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HeroSubgraphService extends BaseSubgraphService {
  private readonly heroesByUserAndLiveGQL: HeroesByUserAndLiveGQL = inject(HeroesByUserAndLiveGQL);
  private readonly heroGQL: HeroGQL = inject(HeroGQL);
  private readonly heroMostPlayedByUserGQL: HeroMostPlayedByUserGQL = inject(HeroMostPlayedByUserGQL);

  constructor() {
    super();
  }

  fetchHeroesByUserAndLive$(user: string): Observable<HeroEntity[]> {
    let lastId = '';
    return this.heroesByUserAndLive$(lastId, user).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          lastId = pos[pos.length - 1].id;
          return this.heroesByUserAndLive$(lastId, user);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as HeroEntity[]),
    );
  }

  hero$(id: string): Observable<HeroEntity> {
    return this.heroGQL.fetch({ heroGraphId: id.toLowerCase() }).pipe(
      map(x => x.data.heroEntity as HeroEntity),
      retry(this.retry()),
    );
  }

  heroMostPlayedByUser$(user: string): Observable<HeroEntity[]> {
    return this.heroMostPlayedByUserGQL.fetch({ user }).pipe(
      map(x => x?.data.heroEntities ?? []),
      map(e => e.map(el => el as HeroEntity)),
      retry(this.retry()),
    );
  }

  private heroesByUserAndLive$(lastId: string, user: string): Observable<HeroEntity[]> {
    return this.heroesByUserAndLiveGQL.fetch({ lastId, user }).pipe(
      map(x => x?.data?.heroEntities ?? []),
      map(e => e.map(el => el as HeroEntity)),
      retry(this.retry()),
    );
  }
}
